import React from "react";

// Customizable Area Start
import {
  Box,
  BoxProps,
  Divider,
  styled,
  Typography
} from "@mui/material";
import CustomInfoDialog from "../../../components/src/CustomInfoDialog.web";
import FullPageLoader from "../../../components/src/FullPageLoader.web";
import NavigationMenu from "../../navigationmenu/src/NavigationMenu.web";
import AppFooter from "../../../components/src/AppFooter.web";
import GoogleAd from "../../../components/src/GoogleAd.web";
// Customizable Area End

import TermsConditionsController, {
  Props,
} from "./TermsConditionsController";

export default class TermsConditions extends TermsConditionsController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    // Customizable Area Start
    const { navigation } = this.props;
    const { allTermsAndConditions, isFullPageLoader, isInfoDialog } = this.state;

    return (
      <TermsStyle>
        <FullPageLoader isLoading={isFullPageLoader} />
        <NavigationMenu navigation={navigation} id={''} />
        <Box className="mainContainer">
          <Box className="subContainer">
            <Box className="titleBox">
              <Typography data-test-id="main-heading" className="mainTitleText">Terms and Conditions</Typography>
            </Box>
            <Divider />
            <div
              data-test-id="main-content"
              className="contentContainer"
              dangerouslySetInnerHTML={{ __html: allTermsAndConditions }}
            />
          </Box>
        </Box>
        <GoogleAd responsive format="auto" sx={{ mt: 6 }} slot="7741279908" />
        <AppFooter navigation={navigation} />
        <CustomInfoDialog
          title=""
          infoType="error"
          data-test-id="info-dialog"
          isOpen={isInfoDialog}
          handleClose={this.handleCloseInfoDialog}
        />
      </TermsStyle>
    );
    // Customizable Area End
  }
}

// Customizable Area Start
export const TermsStyle: React.FC<BoxProps> = styled(Box)({
  "& .mainContainer": {
    backgroundColor: '#EFF6FF',
    padding: '60px'
  },
  "& .subContainer": {
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    padding: '30px'
  },
  "& .mainTitleText": {
    font: "Montserrat",
    fontSize: '24px',
    fontWeight: '600',
    lineHeight: '29.26px',
    color: '#000000',
    letterSpacing: '0%',
    marginBottom: '10px'
  },
  "& .titleBox": {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '5px'
  },
  "& .contentContainer": {
    paddingTop: "10px",
    "& *": {
      fontFamily: "Montserrat, 'sans-serif'",
    },
    p: {
      marginBlockStart: "6px",
      marginBlockEnd: "6px",
    },
    pre: {
      padding: "5px",
      overflowX: "auto",
    },
    blockquote: {
      borderLeft: "4px solid #ccc",
      paddingLeft: "16px",
      margin: "10px 0px"
    },
    ".ql-align-center": {
      textAlign: "center",
    },
    ".ql-align-right": {
      textAlign: "right",
    },
    ".ql-align-justify": {
      textAlign: "justify",
    },
    ".ql-size-small": {
      fontSize: "12px",
    },
    ".ql-size-large": {
      fontSize: "20px",
    },
    ".ql-size-huge": {
      fontSize: "32px",
    },
  },
  "@media (max-width: 768px)": {
    "& .mainContainer ": {
      padding: "20px",
    },
    "& .subContainer": {
      padding: "15px",
    },
    "& .mainTitleText": {
      fontSize: "20px",
      lineHeight: "24px",
      marginBottom: '5px'
    },
    "& .titleBox": {
      padding: "10px",
    },
    contentContainer: {
      padding: "15px",
      maxWidth: "100%",
    },
  },
  "@media (max-width: 480px)": {
    "& .mainContainer": {
      padding: "15px",
    },
    "& .subContainer": {
      padding: "10px",
    },
    "& .mainTitleText ": {
      fontSize: "18px",
      lineHeight: '22px',
      marginBottom: '5px'
    },
    "& .strongSubTitleText": {
      fontSize: "14px",
    }
  }
});

// Customizable Area End
